export enum OwnerType {
    owtPerson = 2,
    owtOrganization = 3
}